export default {
  key: "wishlist",
  basePath: "/wishlist",
  exclude: false,
  components: [],
};
